const halalFoodValues = [
  { title: "Any", value: "" },
  { title: "Easy", value: "3" },
  { title: "Medium", value: "2" },
  { title: "Hard", value: "1" },
];

export default halalFoodValues;
